export const publicEnv = {
  API_HOST: process.env.NEXT_PUBLIC_API_HOST,
  DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
  ENV_NAME: process.env.NEXT_PUBLIC_ENV_NAME,
  APP_AUTH_TOKEN: process.env.NEXT_PUBLIC_APP_AUTH_TOKEN,
  SENTRY_DSN_WEB: process.env.NEXT_PUBLIC_SENTRY_DSN_WEB,
  STRIPE_CLIENT_PUBLIC: process.env.NEXT_PUBLIC_STRIPE_CLIENT_PUBLIC,
  GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
};
